module.exports = __webpack_public_path__ + "img/room.afce402a.svg";